module.exports = __webpack_public_path__ + "19406f767addf00d2ea82cdc9ab104ce.ttf";